// extracted by mini-css-extract-plugin
export default {"userPhoto":"Users_userPhoto__RoULJ","unfollowButton":"Users_unfollowButton__06wv1","followButton":"Users_followButton__zBOiU"};